import { render, staticRenderFns } from "./UploadsList.vue?vue&type=template&id=36f538cc&"
import script from "./UploadsList.vue?vue&type=script&lang=js&"
export * from "./UploadsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports